import { useState } from 'react';
import CurrencyInput from '@/components/base/CurrencyInput';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  employeeName: string;
}

export default function EmployeeOvertimeModal({ isOpen, onClose, onSave, employeeName }: Props) {
  const [form, setForm] = useState({
    overtime_date: new Date().toISOString().split('T')[0],
    hours: 1,
    amount: 0,
    description: '',
  });

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (form.hours <= 0) return;
    onSave(form);
    setForm({ overtime_date: new Date().toISOString().split('T')[0], hours: 1, amount: 0, description: '' });
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose}></div>
      <div className="relative bg-background-50 rounded-2xl w-full max-w-md max-h-[90vh] overflow-hidden shadow-xl flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-background-200/70">
          <h3 className="text-lg font-semibold text-foreground-900">Fazla Mesai Kaydı</h3>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-background-100 cursor-pointer">
            <i className="ri-close-line text-lg text-foreground-500"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <p className="text-sm text-foreground-500">Personel: <span className="font-medium text-foreground-800">{employeeName}</span></p>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1.5">Mesai Tarihi</label>
            <input type="date" value={form.overtime_date} onChange={e => setForm(prev => ({ ...prev, overtime_date: e.target.value }))} className="input-base w-full" />
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1.5">Saat <span className="text-red-400">*</span></label>
            <input type="number" value={form.hours} onChange={e => setForm(prev => ({ ...prev, hours: parseFloat(e.target.value) || 0 }))} className="input-base w-full" min="0" step="0.5" />
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1.5">Mesai Ücreti</label>
            <CurrencyInput value={form.amount} onChange={v => setForm(prev => ({ ...prev, amount: v }))} placeholder="Mesai ücreti" className="w-full" />
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1.5">Açıklama</label>
            <textarea value={form.description} onChange={e => setForm(prev => ({ ...prev, description: e.target.value }))} className="input-base w-full min-h-[70px]" placeholder="Mesai açıklaması..." rows={2}></textarea>
          </div>
        </form>

        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-background-200/70">
          <button type="button" onClick={onClose} className="btn-secondary cursor-pointer whitespace-nowrap">İptal</button>
          <button type="button" onClick={handleSubmit} className="btn-primary cursor-pointer whitespace-nowrap">Kaydet</button>
        </div>
      </div>
    </div>
  );
}